<template>
  <div class="w1200 zhaogu-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">帮扶中心众筹招股</div>
    <div class="lottery">
      <span v-for="(item, index) in lottery.arr" :key="index" :class="lottery.active == index ? 'active' : ''"
            @click="lottery.active = index; getList()">{{ item.dictLabel }}</span>
      <div class="msg">实体投注站帮扶中心</div>
    </div>
    <div class="sub">
      <div>
        <span>众筹招股投注站战绩</span>
        <div class="msg" v-if="lottery.active == 0">
          <span>实战超市方案价格+方案本金=实战总额</span>
          <span>1元=1缩币</span>
          <span>开奖当天18:30停止认购实战方案</span>
          <span>实战票当天20:00以后公示</span>
        </div>
        <div class="msg" style="flex-direction: column;" v-if="lottery.active == 1">
          <div>
            温馨提示：目前开放双色球和大乐透，仅实体投注站可以认购
          </div>
          <div style="display: flex; gap: 0 40px;">
            <span>实战超市方案价格 + 方案本金 = 实战总额</span>
            <span>1元=1缩币</span>
          </div>
        </div>
      </div>
      <span class="btn">投注站申请帮扶</span>
    </div>
    <div class="tit">
      <div>
        <h3>{{ latestIssue }}{{ lottery.arr[lottery.active] && lottery.arr[lottery.active].dictLabel }}期实战团队方案汇总</h3>
        <div>
          <span @click="toggleNumber(0)" :class="{ active: flagMark == 0 }">最新期</span>
          <span @click="toggleNumber(1)" :class="{ active: flagMark == 1 }">上一期</span>
          <span @click="toggleNumber(2)" :class="{ active: flagMark == 2 }">下一期</span>
        </div>
      </div>
      <div class="btn">{{ ['蓝球', '后区'][lottery.active] }}由彩票代表确定</div>
      <!-- <div>双色球开奖结果：每周二、四、日21:30</div> -->
      <div v-if="lottery.active == 0">双色球开奖结果：每周二，四，日 21：30</div>
      <div v-if="lottery.active == 1">大乐透开奖结果：每周一，三，六 21：25</div>
      <div v-if="lottery.active == 2">福彩3D开奖结果：每日 21：15（3d试机号18:30）</div>
      <div v-if="lottery.active == 3">排列三开奖结果：每日 20：45</div>
    </div>
    <el-table v-loading="tableLoading" :data="list" :header-cell-style="{ 'textAlign': 'center' }"
              :cell-style="{ 'textAlign': 'center' }">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="issueNumber" label="期号"></el-table-column>
      <el-table-column prop="bettingShopNumber" label="投注站站号"></el-table-column>
      <el-table-column prop="bettingShopAddress" label="投注站地址" show-overflow-tooltip></el-table-column>
      <el-table-column label="众筹招股" width="260">
        <template slot-scope="{ row }">
          <div class="zt-title" @click="goDetail(row)">{{ row.title }}</div>
          <el-button type="text" class="sub-btn" @click="goDetail(row)">查看详情/股权</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="totalShareNumber" label="总股数"></el-table-column>
      <el-table-column label="分享二维码" width="90">
        <template slot-scope="{ row }">
          <img v-if="row.qrcodeUrl" :src="row.qrcodeUrl" class="qr-img" alt="二维码" />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="130">
        <template slot-scope="{ row }">
          <div class="sub-cell">
            <el-tag :type="statusType(row)" size="small">{{ statusText(row) }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="110">
        <template slot-scope="{ row }">
          <div class="sub-cell">
            <el-button v-if="canSubscribe(row)" type="primary" size="mini" @click="goDetail(row)">
              {{ row.mySubscribeStatus == '1' ? '续购' : '认购' }}
            </el-button>
            <el-button v-else-if="row.mySubscribeStatus == '1'" type="info" size="mini" disabled>已认购</el-button>
            <el-button v-else-if="row.isSelfPublished == '1'" type="info" size="mini" disabled>我发布的</el-button>
            <el-button v-else-if="isFull(row)" type="info" size="mini" disabled>已满额</el-button>
            <el-button v-else-if="isExpired(row)" type="warning" size="mini" disabled>已结束</el-button>
            <el-button v-else type="info" size="mini" disabled>不能认购</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="上传实战票">
        <template slot-scope="{ row }">
          <span>{{ row.ticketUploadRatio != null ? row.ticketUploadRatio + '%' : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lotteryDetailStatusText" label="兑奖明细"></el-table-column>
    </el-table>

    <div class="tableMsg">目前开放双色球和大乐透，仅实体投注站可以认购</div>

    <div class="fenye">
      <el-pagination background layout="prev, pager, next" :total="listPagin.total" @current-change="changePage">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import { bettingShopList } from "@/api/apply";

export default {
  data() {
    return {
      lottery: {
        arr: [
          { dictLabel: '双色球', dictValue: '0' },
          { dictLabel: '大乐透', dictValue: '1' },
        ],
        db: [],
        active: '0',
        index: 0
      },

      list: [],

      yingkui_show: false,

      lotteryTeam: [],

      tableLoading: true,
      listPagin: {
        page: 1,
        limit: 10,
        total: 0
      },


      latestIssue: '',  //最新期

      flagMark: 0,  //期号标记   0=最新一期 1=上一期 2=下一期
    }

  },
  mounted() {
    this.getList();
  },
  methods: {
    goBack() {
      this.$router.push('/sttzzbfzx');
    },
    // 跳转众筹招股详情页（详情页内同时提供认购+股权清单入口）
    goDetail(row) {
      if (!row || !row.id) return
      this.$router.push('/sttzzbfzx/zhaogu/detail/' + row.id)
    },
    isLoggedIn() {
      return !!(this.$store && this.$store.state && this.$store.state.vuex_token)
    },
    isExpired(row) {
      if (!row.deadlineTimestamp) return false
      return new Date().getTime() > Number(row.deadlineTimestamp)
    },
    isFull(row) {
      return (row.remainingShareNumber || 0) <= 0
    },
    // 每人认购上限：发布方未设(personLimit<=0)时按 min(总股数,10) 兜底，与后端 resolvePersonLimit 保持一致
    effectivePersonLimit(row) {
      const total = Number(row.totalShareNumber || 0)
      let limit = Number(row.personLimit || 0)
      if (!limit || limit <= 0) {
        limit = Math.min(total, 10)
      }
      return Math.max(limit, 0)
    },
    // 当前用户在该众筹还可续购的股数
    personRemaining(row) {
      const limit = this.effectivePersonLimit(row)
      const already = Number(row.mySubscribedNumber || 0)
      return Math.max(limit - already, 0)
    },
    canSubscribe(row) {
      if (!this.isLoggedIn()) return false
      if (row.isSelfPublished == '1') return false
      if (this.isExpired(row)) return false
      if (this.isFull(row)) return false
      if (this.personRemaining(row) <= 0) return false
      return true
    },
    statusText(row) {
      if (row.mySubscribeStatus == '1') return '已认购' + (row.mySubscribedNumber || 0) + '股'
      if (this.canSubscribe(row)) return '可认购'
      if (this.isExpired(row)) return '已结束'
      return '不能认购'
    },
    statusType(row) {
      if (row.mySubscribeStatus == '1') return 'success'
      if (this.canSubscribe(row)) return 'primary'
      if (this.isExpired(row)) return 'warning'
      return 'info'
    },
    getList() {
      this.tableLoading = true
      const params = {
        preType: Number(this.lottery.active), // 0=双色球 1=大乐透
        type: this.flagMark,                 // 0=最新一期 1=上一期 2=下一期
        preNumber: this.latestIssue,          // 期号，最新期可不传
        pageNum: this.listPagin.page,
        pageSize: this.listPagin.limit,
      }
      bettingShopList(params).then(res => {
        const base = res && res.data !== undefined ? res.data : res
        const mi = base && base.marketInfos
        // 列表数组：优先 crowdfundingList，兼容 marketInfos.rows / 顶层 rows
        const rows = (base && base.crowdfundingList) || (mi && mi.rows) || (base && base.rows) || []
        this.list = rows
        this.listPagin.total = (base && base.total) || (mi && mi.total) || 0
        // 期号：以当前列表首行 issueNumber 作为参考期号，供上一期/下一期翻页
        if (rows.length && rows[0].issueNumber !== undefined) {
          this.latestIssue = rows[0].issueNumber
        }
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    // 分页状态变化
    changePage(e) {
      this.tableLoading = true
      this.listPagin.page = e
      this.getList();
    },
    // 切换期号
    toggleNumber(index) {
      console.log('index', index);

      this.flagMark = index
      // type=0 最新一期：preNumber 置空由后端取最新
      // type=1/2 上一期/下一期：后端按当前 preNumber 推算，前端不再手动加减
      if (index == 0) {
        this.latestIssue = ''
      }
      this.getList()
    },
    // 点击切换团队
    toggleTeam(ite) {
      console.log('item', ite);
      this.lotteryTeam.forEach(item => item.list.forEach(team => team.active = false));
      ite.active = true
      this.getList('team', ite.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.lottery {
  display: flex;
  align-items: center;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5faff 0%, #eaf2fa 100%);
  padding: 8px;
  position: relative;

  span {
    flex: 0 0 auto;
    background-color: #ffffff;
    color: #347caf;
    padding: 12px 46px;
    margin-right: 8px;
    display: inline-block;
    cursor: pointer;
    border-radius: 7px;
    font-size: 15px;
    font-weight: bold;
    border: 1px solid transparent;
    transition: all 0.2s;

    &:hover {
      color: #2a6490;
      background-color: #eef5fb;
    }

    &.active {
      background: linear-gradient(135deg, #347caf 0%, #4a9bd6 100%);
      color: #ffffff;
      box-shadow: 0 3px 10px rgba(52, 124, 175, 0.35);
    }
  }

  .msg {
    margin-left: auto;
    color: #c0392b;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 1px;
    padding-right: 14px;
    position: relative;

    &::before {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #c0392b;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
}

.sub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 22px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5faff 0%, #eaf2fa 100%);
  margin-top: 14px;
  position: relative;

  >div {
    flex: 1;

    >span {
      display: inline-block;
      color: #347caf;
      font-size: 17px;
      font-weight: bold;
      margin-bottom: 8px;
    }
  }

  span {

    &.btn {
      flex: 0 0 auto;
      background: linear-gradient(135deg, #347caf 0%, #4a9bd6 100%);
      color: #ffffff;
      padding: 9px 18px;
      border-radius: 7px;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      box-shadow: 0 3px 10px rgba(52, 124, 175, 0.3);
      transition: all 0.2s;

      &:hover {
        opacity: 0.9;
        box-shadow: 0 4px 14px rgba(52, 124, 175, 0.45);
      }
    }
  }

  .msg {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 24px;
    margin-top: 6px;

    span {
      color: #e67e22;
      font-size: 13px;
      position: relative;
      padding-left: 14px;

      &::before {
        content: "•";
        position: absolute;
        left: 0;
        color: #e67e22;
      }
    }
  }
}

.tit {
  border: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;

  >div {
    display: flex;
    align-items: center;
    margin: 0 20px;

    h3 {
      color: #347caf;
    }

    &.btn {
      background-color: #347caf;
      color: #ffffff;
      padding: 5px 10px;
      border-radius: 5px;
    }

    >div {
      margin-left: 20px;

      span {
        background-color: #dbdbdb;
        padding: 5px 10px;
        border-radius: 5px;
        margin-right: 20px;
        cursor: pointer;

        &.active {
          background-color: #93d2f3;
        }
      }
    }
  }
}

.tableMsg {
  margin-top: 10px;
  text-align: center;
  color: #898af7;
  font-weight: bold;
}

.qr-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  vertical-align: middle;
}

.sub-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.4;
  gap: 10px;
}

.sub-btn {
  padding: 0;
  margin: 0;
}

.zt-title {
  color: #347caf;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    color: #2a6490;
    text-decoration: underline;
  }
}

.fenye {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
    position: absolute;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }
}
</style>